/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const IntegrationCodeEnum = {
    YouBuyDa: 'YBD',
    AmazonMFN: 'MFN',
    AmazonTODAY: 'AMZNTO',
    PlentyMarkets: 'PLENTY',
    OpenTrans: 'OT',
    ECC: 'ECC',
    Mauve: 'MAUVE',
    GlobalSys: 'GSYS',
    GarantiertGeliefert: 'GG',
    Bliggit: 'BLIGGIT',
    MerchantCenter: 'MC',
    Zoho: 'ZOHO',
    ProHandel: 'PROHANDEL',
    HILTES: 'HILTES',
    EasySystems: 'EASY',
    FashionCloud: 'FC',
/**
     * @deprecated Service discontinued by Amazon.
     */    AmazonBOPIS: 'AMZN'
};
